import { render, staticRenderFns } from "./OpcoesMenu.vue?vue&type=template&id=4848dd7b&"
import script from "./OpcoesMenu.vue?vue&type=script&lang=js&"
export * from "./OpcoesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports